import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

import { mount } from 'redom';

import NativeMediaEditControls from './';

import './index.scss';

function NativeMediaEditControlsReactWrapper(props) {

  const wrapperMainReference = useRef(null);
  const nativeMediaEditControlsReference = useRef(null);

  useEffect(function onLoad() {

    if (nativeMediaEditControlsReference.current !== null) {
      return;
    }

    const nativeMediaEditControls = new NativeMediaEditControls(props, props.anchorReference.current);

    nativeMediaEditControlsReference.current = nativeMediaEditControls;

    mount(wrapperMainReference.current, nativeMediaEditControlsReference.current);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onPropsChange() {

    nativeMediaEditControlsReference.current.update(props, props.anchorReference.current);

  }, [props]);

  function renderMain() {

    const mainAttributes = {
      className: 'media-edit-controls-react-wrapper-main',
      ref: wrapperMainReference
    };

    return ReactDOM.createPortal(<div {...mainAttributes}>

    </div>, document.body);

  }

  return renderMain();

}

export default NativeMediaEditControlsReactWrapper;